import "./contact.3c53636b.js";


      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired972"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired972"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

var $4AGbv = parcelRequire("4AGbv");

var $beOXE = parcelRequire("beOXE");
var $iNA1s = parcelRequire("iNA1s");
const $d0913dba05d7f994$var$AnchorBtnBack = document.querySelector(".inside-page-back");
document.addEventListener("DOMContentLoaded", function() {
    (0, $4AGbv.gsap).registerPlugin((0, $beOXE.ScrollSmoother), (0, $iNA1s.ScrollTrigger));
    let smoother = (0, $beOXE.ScrollSmoother).create({
        wrapper: "#smooth-wrapper-inside",
        content: "#smooth-content-inside",
        smooth: 2,
        smoothTouch: 0.1
    });
});
$d0913dba05d7f994$var$AnchorBtnBack.addEventListener("click", function(e) {
    e.preventDefault();
    history.back();
});


//# sourceMappingURL=inside-darsy.aab5a2f8.js.map
